import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import UploadFile from '../../../../components/UploadFile';
import { useForm } from 'react-hook-form';

const SupportTicketForm = (props) => {
  const { register, handleSubmit, control, reset, formState: { errors } } = useForm({});
  const [uploadedUrls, setUploadedUrls] = useState([]);
  const options = props.productOptions.map(product => ({
    value: product.id,
    label: product.name,
  }));
  const handleFileUpload = (urls) => {
    setUploadedUrls(urls);
  };

  const handleClose = () => {
    reset();
    props.setListType('list');
    setUploadedUrls([]);
  };

  const onSubmit = (data) => {
    props.onTicketSubmit(data);
  };

  return (
    <form onSubmit={handleSubmit((data) => onSubmit({ ...data, document: uploadedUrls }))}>
      <div className="mb-3">
        <label className="form-label fw-bold">Product</label>
        <Controller
          name="customer_product_id"
          control={control}
          rules={{ required: 'Product is required.' }}
          render={({ field }) => (
            <select {...field} className="form-select">
              <option value="">Select a Product</option>
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          )}
        />
        {errors.product_id && <small className="text-danger">{errors.product_id.message}</small>}
      </div>
      <div className="mb-3">
        <label className="form-label fw-bold">Priority</label>
        <Controller
          name="priority"
          control={control}
          rules={{ required: 'Priority is required.' }}
          render={({ field }) => (
            <select {...field} className="form-select">
              <option value="">Select a priority</option>
              {props.priorityOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          )}
        />
        {errors.priority && <small className="text-danger">{errors.priority.message}</small>}
      </div>

      <div className="mb-3">
        <label className="form-label fw-bold">Status</label>
        <Controller
          name="status"
          control={control}
          render={({ field }) => (
            <select {...field} className="form-select">
              <option value="">Select a status</option>
              {props.statusOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          )}
        />
        {errors.status && <small className="text-danger">{errors.status.message}</small>}
      </div>
      <div className="mb-3">
        <div className="col">
          <label className="fw-bold">Title</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter title"
            {...register('title', {
              required: 'Title is required.',
              maxLength: {
                value: 60,
                message: 'Title must not exceed 60 characters.',
              },
            })}
          />
          {errors.title && (
            <p className="text-danger mt-2">{errors.title.message}</p>
          )}
        </div>
      </div>
      <div className="mb-3">
        <label className="form-label fw-bold">Description</label>
        <textarea
          className="form-control"
          placeholder="Enter description"
          {...register('description', {
            required: 'Description is required.',
            maxLength: {
              value: 255,
              message: 'Description must not exceed 255 characters.',
            },
          })}
        />
        {errors.description && <small className="text-danger">{errors.description.message}</small>}
      </div>

      <div className="mb-3">
        <label className="form-label fw-bold">Document</label>
        <UploadFile folderName="support-ticket" onFileUpload={handleFileUpload} />
      </div>

      <div className="text-end">
        <button type="button" className="btn btn-sm btn-danger me-2" onClick={handleClose}>
          Cancel
        </button>
        <button type="submit" className="btn btn-sm btn-primary">
          Save
        </button>
      </div>
    </form>

  )
}

export default SupportTicketForm
